export default {
  props: {
    classes: {
      type: String,
      default: 'uk-button uk-button-primary uk-button-small',
    },
  },
  computed: {
    current_page() {
      if(this.$store.state.grid.meta.pagination) {
        return this.$store.state.grid.meta.pagination.current_page;
      }
      return 0;
    },
    total_pages() {
      if(this.$store.state.grid.meta.pagination) {
        return this.$store.state.grid.meta.pagination.total_pages;
      }
      return 0;
    },
  },
  methods: {
    nextPage() {
      this.$store.commit('grid/nextPage');
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridLoadMore.js